import {
  FormSearchSelection,
  type ReadonlyFieldProps,
  type FormSearchSelectionProps,
  ReadonlyField,
} from '@shared/components';
import { type FieldValues } from 'react-hook-form';

import type { BaseInputModeProps, BaseViewModeProps } from '../../types';

type InputModeProps = BaseInputModeProps<
  Omit<FormSearchSelectionProps<FieldValues>, 'name' | 'mode'>
>;

type ViewModeProps = BaseViewModeProps<Omit<ReadonlyFieldProps, 'content'>>;

export type SearchSelectionRendererProps = InputModeProps | ViewModeProps;

export default function SearchSelectionRenderer(props: Readonly<SearchSelectionRendererProps>) {
  switch (props.mode) {
    case 'input': {
      const { name, slotProps = { options: [] } } = props;
      return <FormSearchSelection name={name} {...slotProps} />;
    }
    case 'view': {
      const { value, slotProps } = props;
      return <ReadonlyField content={value} {...slotProps} />;
    }
  }
}
